import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetClasses = (organizationId: string, includeStudents: boolean, callback?: (selectedClassId: string) => void) => {
  const classesService = useServices().classesService;
  return useQuery({
    queryKey: ['organizationClasses', organizationId],
    queryFn: async () => {
      const response = await classesService.getClasses(organizationId, includeStudents);

      if (callback) {
        callback(response.length ? response[0].id : '');
      }

      return response;
    },
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
}